import { Skeleton } from 'antd';

/**
 * Overview tab skeleton — Hero kartochka + Tez amallar + Boshqaruv
 * nav kartochkalar uchun placeholder.
 */
export default function OverviewSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }} className="bl-animate-in">
      {/* Hero placeholder */}
      <div
        style={{
          borderRadius: 20,
          background: 'var(--bl-surface-soft, #eef0f3)',
          height: 144,
          overflow: 'hidden',
          padding: '20px 16px 16px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <Skeleton.Avatar active size={64} shape="square" style={{ borderRadius: 16 }} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Skeleton.Input active size="small" style={{ width: 160, height: 20 }} />
            <Skeleton.Input active size="small" style={{ width: 100, height: 13 }} />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Skeleton.Input active size="small" style={{ width: 70, height: 22, borderRadius: 999 }} />
          <Skeleton.Input active size="small" style={{ width: 70, height: 22, borderRadius: 999 }} />
        </div>
      </div>

      {/* Quick actions caption + 2 tiles */}
      <div style={{ marginTop: 6 }}>
        <Skeleton.Input active size="small" style={{ width: 110, height: 11, marginBottom: 10 }} />
        <div style={{ display: 'flex', gap: 8 }}>
          {[0, 1].map((i) => (
            <div
              key={i}
              style={{
                flex: 1,
                background: 'var(--bl-surface, #fff)',
                border: '1px solid var(--bl-divider, #ebebeb)',
                borderRadius: 14,
                padding: '12px',
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                minHeight: 86,
              }}
            >
              <Skeleton.Avatar active size={36} shape="square" style={{ borderRadius: 11 }} />
              <Skeleton.Input active size="small" style={{ width: '80%', height: 13 }} />
              <Skeleton.Input active size="small" style={{ width: '60%', height: 11 }} />
            </div>
          ))}
        </div>
      </div>

      {/* Manage caption + 2 nav cards */}
      <div style={{ marginTop: 6 }}>
        <Skeleton.Input active size="small" style={{ width: 90, height: 11, marginBottom: 10 }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[0, 1].map((i) => (
            <div
              key={i}
              style={{
                background: 'var(--bl-surface, #fff)',
                border: '1px solid var(--bl-divider, #ebebeb)',
                borderRadius: 14,
                padding: '12px 14px',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
              }}
            >
              <Skeleton.Avatar active size={42} shape="square" style={{ borderRadius: 12 }} />
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Skeleton.Input active size="small" style={{ width: 100, height: 14 }} />
                <Skeleton.Input active size="small" style={{ width: 140, height: 11 }} />
              </div>
              <Skeleton.Input active size="small" style={{ width: 12, height: 12 }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
